module.exports = __webpack_public_path__ + "img/bottom-logo@2x.9b7b0299.png";